import {
  test_mixin,
  textual_score,
} from './mixins'

import {
  markup,
  reverse_markup,
  round_up,
  format_date_with_month,
  map_markers,
  map_markers_v3,
  format_beds,
  get_live_price_no_tax,
  build_data_items,
  get_total_nights,
  get_label_occupancy,

  get_suggested_booking_dates, 
  markupPricing, 
  format_booking_dates_range, 
} from './utilities'

export {
  // mixins
  test_mixin,
  textual_score,
  // functions
  markup,
  reverse_markup,
  round_up,
  format_date_with_month,
  map_markers,
  map_markers_v3,
  format_beds,
  get_live_price_no_tax,
  build_data_items,
  get_total_nights,
  get_label_occupancy,

  get_suggested_booking_dates, 
  markupPricing, 
  format_booking_dates_range, 
}